// src/components/NotebookBackground.js
import React from 'react';
import doodlePattern from './grid.svg';

const NotebookBackground = () => {
  return (
    <div
      className="absolute inset-0 -z-10"
      style={{
        backgroundImage: `url(${doodlePattern})`,
        backgroundRepeat: 'repeat',
        backgroundSize: '29px 29px',
      }}
    />
  );
};

export default NotebookBackground;